export default __webpack_public_path__ + "static/media/inhouse-icon3.e0819153.svg";